import { Decimal } from "shared-ts/classes/decimal"

export const CellModes = {
  READ_ONLY: "readOnly",
  INLINE_EDIT: "inlineEdit",
  EDITABLE: "editable",
} as const

export const CellSaleStates = {
  NON_PROCESSED: "non-processed", // created, quotes, will calls
  COMPLETED: "completed",
  RETURNING: "returning",
  SPECIAL_ORDER: "special-order",
} as const

export const CellProductType = {
  PRODUCT: "product",
  KIT: "kit",
  KIT_COMPONENT: "kitComponent",
} as const

type CellProductTypeValue =
  (typeof CellProductType)[keyof typeof CellProductType]

export type CellProductOrKit = Exclude<
  CellProductTypeValue,
  typeof CellProductType.KIT_COMPONENT
>

export type CellProductOrKitComponent = Exclude<
  CellProductTypeValue,
  typeof CellProductType.KIT
>

export type SaleProductLine =
  | { productType: typeof CellProductType.PRODUCT }
  | { productType: typeof CellProductType.KIT_COMPONENT; kitCount: Decimal }
